module.exports = __webpack_public_path__ + "nam_icon.svg";